import {
    Container,
    Grid,
} from "@material-ui/core"
import TProveedoresMayorista from "../TProveedorMayorista"
import { useDispatch } from "react-redux"
import { Fragment, useEffect } from "react"
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
import { obtenerPaqueteMayoristaAllAction } from "../../../ducks/proveedorMayoristaDuck"
import FPaqueteMayorista from "../FPaqueteMayorista"

const usePaqueteMayorista = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({message: ""}))
        dispatch(obtenerPaqueteMayoristaAllAction()).then(Response => {
            dispatch(offLoadAction())
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
}

const VProveedorMayorista = () => {
    usePaqueteMayorista()
    return (
        <Fragment>
            <Container maxWidth="xl" style={{ marginTop: "2rem" }}>
                <Grid item xs={12}>
                    <FPaqueteMayorista />
                </Grid>
                <Grid item xs={12}>
                    <TProveedoresMayorista />
                </Grid>
            </Container>
        </Fragment>
    )
}
export default VProveedorMayorista